(() => {
  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  const closeButtons = popup.querySelectorAll('[data-newsletter-popup-close]');
  const emailInput = popup.querySelector('input[type="email"]');
  let previouslyFocused = null;

  const wasShown = () => {
    try {
      return window.sessionStorage.getItem('sandyNewsletterPopupShown') === 'true';
    } catch (error) {
      return false;
    }
  };

  const rememberShown = () => {
    try {
      window.sessionStorage.setItem('sandyNewsletterPopupShown', 'true');
    } catch (error) {
      // The popup still works when storage is unavailable.
    }
  };

  const openPopup = () => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const consentDialog = document.querySelector('[role="alertdialog"]');
    if (mobile && consentDialog && consentDialog.getClientRects().length) {
      window.setTimeout(openPopup, 1000);
      return;
    }
    previouslyFocused = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('newsletter-popup-open');
    window.setTimeout(() => {
      if (popup.hidden) return;
      const target = mobile ? popup.querySelector('.newsletter-popup__close') : emailInput;
      target?.focus({ preventScroll: true });
    }, 50);
  };

  const closePopup = () => {
    popup.hidden = true;
    document.body.classList.remove('newsletter-popup-open');
    rememberShown();
    previouslyFocused?.focus?.();
  };

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup();
  });

  const hasFormResponse = new URLSearchParams(window.location.search).has('customer_posted');
  const mobile = window.matchMedia('(max-width: 749px)').matches;

  if (hasFormResponse) {
    window.setTimeout(openPopup, 100);
  } else if (!wasShown() && mobile) {
    let triggerTimer;

    const triggerMobilePopup = () => {
      window.clearTimeout(triggerTimer);
      window.removeEventListener('scroll', handleMobileScroll);
      openPopup();
    };

    const handleMobileScroll = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight > 0 && window.scrollY / scrollableHeight >= 0.35) {
        triggerMobilePopup();
      }
    };

    window.addEventListener('scroll', handleMobileScroll, { passive: true });
    triggerTimer = window.setTimeout(triggerMobilePopup, 12000);
  } else if (!wasShown()) {
    window.setTimeout(openPopup, 5000);
  }
})();
